export default __webpack_public_path__ + "static/media/Envelope.fc0544c6.svg";